module.exports = __webpack_public_path__ + "img/text-image-news.4719de36.svg";